import { render, staticRenderFns } from "./PanelBottom.vue?vue&type=template&id=6b4c13ae&"
import script from "./PanelBottom.vue?vue&type=script&lang=js&"
export * from "./PanelBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports